import { useGetFunctionQuery } from '@/store/api/assistantApi';

export const useGetFunction = (id: string) =>
  useGetFunctionQuery({ functionId: id }, { skip: !id });
